import React from 'react'
import { Button } from 'antd'

import Delete from '~/components/deleteConfirm'

// TODO: change Texto(s)

export const getColumns = (handleToGo, handleDelete) => [
	{
		title: 'Nome',
		dataIndex: 'title',
		key: 'title',
		render: (text, row) => (
			<Button type="link" onClick={() => handleToGo(row)}>
				{text}
			</Button>
		),
	},
	{
		title: 'Quantidade de dados',
		dataIndex: 'row_count',
		key: 'row_count',
		render: (count) => (count === 1 ? '1 linha' : count + ' linhas'),
	},
	{
		title: '',
		dataIndex: 'action',
		key: 'action',
		render: (text, row) => (
			<Delete
				title="Deseja excluir esse banco de textos?"
				handle={() => handleDelete(row)}
			/>
		),
	},
]
